import React, { useEffect, useState } from "react";
import Stat from "./Stat";
import { Layout, Tabs } from "antd";

const getSelectedTabFromUri = () => {
  return window.location?.hash?.substring(1);
};

export default function EstherIndividualStat() {
  const [tabKey, setTabKey] = useState('1');

  function handleChangeTab(tabKeyValue) {
    window.location.hash = tabKeyValue;
    setTabKey(tabKeyValue);
  }

  useEffect(() => {
    const selectedTabKey = getSelectedTabFromUri();
    if (selectedTabKey) {
      setTabKey(selectedTabKey);
    }
  }, []);

  const tabItems = [
    { label: '주영', key: '1', children: <Stat playerName={'주영'} /> },
    { label: '동훈', key: '2', children: <Stat playerName={'동훈'} /> },
    { label: '예지', key: '3', children: <Stat playerName={'예지'} /> },
    { label: '강희', key: '4', children: <Stat playerName={'강희'} /> },
    { label: '다은', key: '5', children: <Stat playerName={'다은'} /> }
  ];

  return (
    <Layout style={{ background: '#ffffff' }}>
      <Layout.Content style={{ padding: '20px' }}>
        <Tabs activeKey={tabKey} onChange={handleChangeTab} items={tabItems} />
      </Layout.Content>
    </Layout>
  );
}
